import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import { Fade } from 'react-reveal'

import media from '../../../services/generateMediaQueries'

import ZingIcon from '../../../assets/img/zing-icon.svg'

let LOADING = false

const StyledLink = styled(Link)`
  text-decoration: none;
`

const CardImage = styled.div.attrs(props => ({
  style: {
    background: `linear-gradient(rgba(141,122,157,0.40), rgba(141,122,157,0.40)), url('${props.cardImageUrl}') 0% 0% / cover, linear-gradient(#000000, #000000)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
}))`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: #000000;
  transition: all 0.5s;
`

const StyledCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 300px;
  margin: 0 0.625rem;
  border-radius: var(--border-radius-card);
  box-shadow: var(--box-shadow-large);
  overflow: hidden;
  background: linear-gradient(
      rgba(141, 122, 157, 0.4),
      rgba(141, 122, 157, 0.4)
    ),
    #f9f9f9;

  ${() =>
    LOADING &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
    `}

  ${media.lessThan('large')`
    margin: 0 0.5rem;
  `}

  &:hover {
    ${CardImage} {
      transform: scale(1.2);
    }
  }
`

const CardWrapper = styled.div`
  outline: none;
`

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.5rem 2.5rem;
  height: 100%;
  border-radius: var(--border-radius-card);
  color: #ffffff;
  text-align: center;
  z-index: 1;
`

const Logo = styled.div.attrs(props => ({
  style: {
    backgroundImage: `url('${props.image}')`,
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
}))`
  border-radius: 0.3125rem;
  height: 3.6875rem;
  width: 3.6875rem;
  margin: 2rem auto;
`

const Title = styled.h1`
  font-size: 1.25rem;
  line-height: 1.75rem;
  letter-spacing: 0.28px;
  font-weight: var(--font-weight-boldest);
  letter-spacing: 0.28px;
  margin: 0;
  text-transform: uppercase;
`

const Subtitle = styled.p`
  font-size: 0.875rem;
  line-height: 1.1875rem;
  letter-spacing: 0.29px;
  margin: 0;
`

const Text = styled.p`
  margin: 0;
  color: #ffffff;
`

const ZingIconComponent = styled.img.attrs({ src: ZingIcon })`
  margin: 1rem;
`

function ShopDineCard(props) {
  const {
    cardImageUrl = '',
    iconUrl = '',
    title = '',
    subtitle = '',
    link = '',
    id = 0,
    onClick,
    onRetry,
    loading = false,
    error = false,
    errorMessage = '',
  } = props

  LOADING = loading

  const CardComponent = () => (
    <CardWrapper>
      <StyledLink
        to={link}
        onClick={
          error
            ? e => {
                e.preventDefault()
                onRetry()
              }
            : onClick
        }
      >
        <StyledCard>
          {!LOADING ? (
            <>
              <CardImage cardImageUrl={cardImageUrl} />
              <CardContent>
                <Logo image={iconUrl} />
                <Title>{title}</Title>
                <Subtitle>{subtitle}</Subtitle>
              </CardContent>
            </>
          ) : (
            <>
              <ZingIconComponent />
              {error && (
                <>
                  <Text>{errorMessage || 'Failed to load Explore.'}</Text>
                  <Text>Tap to retry.</Text>
                </>
              )}
            </>
          )}
        </StyledCard>
      </StyledLink>
    </CardWrapper>
  )

  if (LOADING) {
    return <CardComponent />
  }

  return (
    <Fade right distance="1rem" delay={300 + 50 * id} duration={300} force>
      <CardComponent />
    </Fade>
  )
}

ShopDineCard.defaultProps = {
  link: '',
  errorMessage: '',
}

ShopDineCard.propTypes = {
  cardImageUrl: PropTypes.string,
  iconUrl: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  link: PropTypes.string,
  onClick: PropTypes.func,
  onRetry: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
}

export default ShopDineCard
